import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class XsrfService {
  private xsrfToken: string;

  private readonly requiredMethods: string[] = ['PATCH', 'POST', 'PUT', 'DELETE'];

  store(xsrfToken: string): void {
    this.xsrfToken = xsrfToken;
  }

  load(): string {
    return this.xsrfToken;
  }

  exists(): boolean {
    return !!this.xsrfToken;
  }

  methodRequired(method: string): boolean {
    return this.requiredMethods.includes(method);
  }
}
